import { render, staticRenderFns } from "./CellActions.vue?vue&type=template&id=85745da4"
import script from "./CellActions.vue?vue&type=script&lang=js"
export * from "./CellActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports